import React, { useEffect } from "react";
import { setAdminPlusRankingPoints } from "../../../utils/service/ranking";

export default function Bsa(props) {
  function pointAction(type) {
    setAdminPlusRankingPoints(
      type,
      props.state.user.registration,
      "c90a159e-e538-43d3-a66b-82292586912f"
    );
  }

  useEffect(() => {
    document.getElementById("title-card-optionArea").focus();
  }, []);
  return (
    <div className="div-optionArea">
      <div className="card-talent">
        <a className="title-card-talent" id="title-card-optionArea" tabIndex={13}>
          Alianças
        </a>
        <video
          width={250}
          controls
          tabIndex={14}
          onPlay={() => pointAction("PALCO2ALIANCAS")}
        >
          <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/PALCO%202/BSA/BSA%20-%20Alian%C3%A7as%20%28Noufer%29%20v2_COM_QR%20CODE.mp4" />
        </video>
      </div>

      <div className="card-talent">
        <a className="title-card-talent" id="title-card-talent" tabIndex={15}>
          Finanças
        </a>
        <video
          width={250}
          controls
          tabIndex={15}
          onPlay={() => pointAction("PALCO2FINANCAS")}
        >
          <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/PALCO%202/BSA/Bsa%20-%20Finan%C3%A7as%20%28F%C3%A1bio%29%20Com%20Qr%20Code_v2.mp4" />
        </video>
      </div>

      <div className="card-talent">
        <a className="title-card-talent" id="title-card-talent" tabIndex={15}>
          Jurídico
        </a>
        <video
          width={250}
          controls
          tabIndex={16}
          onPlay={() => pointAction("PALCO2JURIDICO")}
        >
          <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/PALCO%202/BSA/BSA%20-%20Jur%C3%ADdico%20%28Patricia%29%20COM_QR%20CODE.mp4" />
        </video>
      </div>

      <div className="card-talent">
        <a className="title-card-talent" id="title-card-talent" tabIndex={15}>
          Marketing
        </a>
        <video
          width={250}
          controls
          tabIndex={17}
          onPlay={() => pointAction("PALCO2MARKETING")}
        >
          <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/PALCO%202/BSA/BSA%20-%20Marketing%20%28Flavia%29%20V2_COM_QR%20CODE.mp4" />
        </video>
      </div>

      <div className="card-talent">
        <a className="title-card-talent" id="title-card-talent" tabIndex={15}>
          Segurança Corporativa
        </a>
        <video
          width={250}
          controls
          tabIndex={18}
          onPlay={() => pointAction("PALCO2SEGURANCACORPORATIVA")}
        >
          <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/PALCO%202/BSA/BSA%20-%20Seguran%C3%A7a%20Corporativa%20%28Erick%29%20COM_QR%20CODE%283%29.mp4" />
        </video>
      </div>

      <div className="card-talent">
        <a className="title-card-talent" id="title-card-talent" tabIndex={15}>
          People
        </a>
        <video
          width={250}
          controls
          tabIndex={19}
          onPlay={() => pointAction("PALCO2PEOPLE")}
        >
          <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/PALCO%202/BSA/BSA%20-%20People%20%28Tatiana%29%2008_12_2022.mp4" />
        </video>
      </div>

      <div className="card-talent">
        <a className="title-card-talent" id="title-card-talent" tabIndex={15}>
          Operações e Staffing
        </a>
        <video
          width={250}
          controls
          tabIndex={20}
          onPlay={() => pointAction("PALCO2OPERACOESESTAFFING")}
        >
          <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/PALCO%202/BSA/BSA%20-%20Opera%C3%A7%C3%B5es%20e%20Staffing%20%28C%C3%ADcero%29%20COM_QR%20CODE.mp4" />
        </video>
      </div>
    </div>
  );
}
